/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put } from 'redux-saga/effects';
import { QUEUE_CLOSE_SUCCESS } from '../features/queues';

function* queueClosed(action: any) {
  yield put({ type: QUEUE_CLOSE_SUCCESS, queueId: action.requestId });
}

export function* handleQueueCloseSaga() {
  yield takeLatest('web-socket/booth-queue-close/cbx', queueClosed);
}
